import * as v from 'valibot';

import { type Entities, optionSchema } from './_core.model';

export const stateApiSchema = v.object({
  stateCode: v.string(),
  stateDesc: v.string(),
});

export const statesApiSchema = v.array(stateApiSchema);

export const statesParamsSchema = v.object({
  CountryCode: v.string(),
});

export type StateApi = v.InferOutput<typeof stateApiSchema>;
export type StatesApi = v.InferOutput<typeof statesApiSchema>;
export type StatesParams = v.InferOutput<typeof statesParamsSchema>;

export const stateSchema = v.object({
  ...optionSchema.entries,
});

export type State = v.InferOutput<typeof stateSchema>;

export type States = Entities<State>;

export type StateFilters = {
  search?: {
    stateCode?: string;
    stateDesc?: string;
  };
};
